import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { primengTranslate } from '@pco-front-assets/js/primeng-translates';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  imports: [
    RouterOutlet,
    CommonModule,
  ],
  selector: 'pco-root',
  standalone: true,
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(private readonly primeng: PrimeNGConfig) {
    this.primeng.setTranslation(primengTranslate);
  }

  ngOnInit(): void {
    this.primeng.ripple = true;
  }
}
